// @core/api/endpoints/attachment/get_multipart_upload_part_url.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetMultipartUploadPartUrlRequest,
  GetMultipartUploadPartUrlResponse,
} from '../../../types/attachment';

const BASE_PATH = '/attachment';

/**
 * Get presigned URL for multipart upload part
 * Generates a presigned URL for uploading a specific part of a multipart upload. Use when the initial URLs have expired or for retry scenarios.
 */
export async function GetMultipartUploadPartUrl(
  data: GetMultipartUploadPartUrlRequest,
  options?: RequestOptions
): Promise<GetMultipartUploadPartUrlResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/attachments/multipart/part-url`;
  const requestOptions = options;
  return client.post<GetMultipartUploadPartUrlResponse>(requestPath, data, requestOptions);
}
